import { memo } from "react";
import { ViewTableCell } from "@design-system/ViewTable/ViewTableCell";

interface JournalEntryVersionLinesCellProps {
    row: { original: { linesCount: number } };
}

export const JournalEntryVersionLinesCell = memo(
    ({ row }: JournalEntryVersionLinesCellProps) => (
        <ViewTableCell>{row.original.linesCount}</ViewTableCell>
    ),
);

JournalEntryVersionLinesCell.displayName = "JournalEntryVersionLinesCell";
